import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import fun from "../assets/script/function";

import routes from './routes';

Vue.use(VueRouter);

Vue.prototype.navigateTo = function(link, open) {
	if (
		(typeof link == 'string' && this.$route.path == link) ||
		(typeof link == 'object' && link.name && this.$route.name == link.name) ||
		(typeof link == 'object' && link.path && this.$route.name == link.path)
	) return;
	if (open) {
		window.open(this.$router.resolve(link).href);
	} else {
		this.$router.push(link);
	}
};
Vue.prototype.redirectTo = function(link) {
	window.$app.$children[0].$children.find(item => item.$options.name == 'cmsWrapper').closeAlivePage();
	this.navigateTo(link);
};
Vue.prototype.navigateBack = function(n = -1) {
	this.$router.go(n);
};

const router = new VueRouter({
	mode: 'history',
	base: '/',
	routes
});

router.beforeEach((to, form, next) => {
	if (to.path != '/login') {
		if (!store.state.session) {
			next('/login');
		} else if (to.path.includes('mobile')) {
			next('/');
		} else {
			next();
		}
	} else {
		next();
	}
});

export default router